module.exports = __webpack_public_path__ + "3408444b3e26c18c81e54b1994e46d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/price.png
// module id = 279
// module chunks = 0